import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import About from '@/pages/About'
import Legal from '@/pages/Legal'
import Vacancies from '@/pages/Vacancies'
import Regions from '@/pages/Regions'
import Contacts from '@/pages/Contacts'
import Power from '@/pages/Power'
import Accounting from '@/pages/Accounting'
import Audit from '@/pages/Audit'
import Consulting from '@/pages/Consulting'
import Trading from '@/pages/Trading'
import News from '@/pages/News'
import Profile from '@/pages/Profile'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/legal',
      name: 'legal',
      component: Legal
    },
    {
      path: '/vacancies',
      name: 'vacancies',
      component: Vacancies
    },
    {
      path: '/regions',
      name: 'regions',
      component: Regions
    },
    {
      path: '/power',
      name: 'power',
      component: Power
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: Contacts
    },
    {
      path: '/accounting',
      name: 'accounting',
      component: Accounting
    },
    {
      path: '/audit',
      name: 'audit',
      component: Audit
    },
    {
      path: '/consulting',
      name: 'consulting',
      component: Consulting
    },
    {
      path: '/trading',
      name: 'trading',
      component: Trading
    },
    {
      path: '/news',
      name: 'news',
      component: News
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js